import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDebidCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "uuid-956b7346-92f1-4587-9176-9924b0d29bb9",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 100 100",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .uuid-2deae15f-126f-4af5-b535-1e6ea0ec93d4 {\n        fill: none;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "uuid-2deae15f-126f-4af5-b535-1e6ea0ec93d4",
			d: "M79.07,31.48l-.02,5.04H20.89v-5.08c-.06-1.06.7-1.92,1.75-2.02h54.55c1.12.06,1.92.93,1.88,2.05Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "uuid-2deae15f-126f-4af5-b535-1e6ea0ec93d4",
			d: "M79.05,42.23H20.89v26.7c.1.91.86,1.62,1.86,1.67h54.55c.97-.11,1.66-.8,1.77-1.77l-.02-26.61ZM40.31,60.53c-.51.53-1.16.82-1.86.82l-8.84.02c-.68,0-1.35-.29-1.84-.8-.55-.57-.86-1.33-.84-2.09.02-1.52,1.28-2.78,2.76-2.78h8.64c1.48,0,2.7,1.18,2.8,2.68.04.78-.27,1.58-.8,2.15Z"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M84.68,30.82c-.02-4.37-4.07-7.08-7.82-7.08l-54.32.04c-3.88,0-7.29,3.29-7.29,7.02l.02,38.52c0,1.85.82,3.6,2.3,4.95,1.41,1.27,3.25,2,5.04,2h54.76c3.84,0,7.08-3.08,7.36-7v-.02l-.06-38.42ZM77.3,70.61H22.75c-1.01-.06-1.77-.76-1.86-1.67v-26.7h58.17l.02,26.61c-.11.97-.8,1.66-1.77,1.77ZM79.05,36.52H20.89v-5.08c-.06-1.06.7-1.92,1.75-2.02h54.55c1.12.06,1.92.93,1.88,2.05l-.02,5.04Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M41.11,58.38c.04.78-.27,1.58-.8,2.15-.51.53-1.16.82-1.86.82l-8.84.02c-.68,0-1.35-.29-1.84-.8-.55-.57-.86-1.33-.84-2.09.02-1.52,1.28-2.78,2.76-2.78h8.64c1.48,0,2.7,1.18,2.8,2.68Z" })
	]
});
export default SvgDebidCard;
